import React from "react";

const ContinuousBackground = ({ children }) => {
  return (
    <div className="relative min-h-screen bg-black text-white overflow-hidden">
      {/* Shared base background with gradient */}
      <div className="fixed inset-0 bg-gradient-to-b from-black via-black/95 to-black/90 z-0"></div>

      {/* Shared grid pattern that spans the entire page */}
      <div
        style={{
          backgroundImage: `linear-gradient(#00FF8F 1px, transparent 1px), linear-gradient(90deg, #00FF8F 1px, transparent 1px)`,
          backgroundSize: "60px 60px",
        }}
        className="fixed inset-0 opacity-10 z-0"
      ></div>

      {/* Content container */}
      <div className="relative z-10">{children}</div>

      {/* Shared teal glows positioned across page */}
      <div className="fixed top-1/4 left-1/3 w-96 h-96 rounded-full bg-market-teal/10 filter blur-[100px] z-0 animate-slow-pulse"></div>
      <div
        className="fixed bottom-1/4 right-1/3 w-80 h-80 rounded-full bg-market-teal/10 filter blur-[100px] z-0 animate-slow-pulse"
        style={{ animationDelay: "2s" }}
      ></div>
      <div
        className="fixed top-2/3 left-1/4 w-72 h-72 rounded-full bg-market-teal/5 filter blur-[100px] z-0 animate-slow-pulse"
        style={{ animationDelay: "4s" }}
      ></div>
    </div>
  );
};

export default ContinuousBackground;
